export default "__VITE_ASSET__27ff2273__"